import { render, staticRenderFns } from "./SwitchButton.vue?vue&type=template&id=73cfd8e1&scoped=true&"
import script from "./SwitchButton.vue?vue&type=script&lang=js&"
export * from "./SwitchButton.vue?vue&type=script&lang=js&"
import style0 from "./SwitchButton.vue?vue&type=style&index=0&id=73cfd8e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73cfd8e1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73cfd8e1')) {
      api.createRecord('73cfd8e1', component.options)
    } else {
      api.reload('73cfd8e1', component.options)
    }
    module.hot.accept("./SwitchButton.vue?vue&type=template&id=73cfd8e1&scoped=true&", function () {
      api.rerender('73cfd8e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/UI/SwitchButton.vue"
export default component.exports